import React, { useState } from 'react'
import { handleKeyDown } from '@/utils/functions/handleKeyDown'
import BadgeIcon from '@mui/icons-material/Badge'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'

import PropTypes from 'prop-types'
import { STextField } from './styles'

import s from './styles.module.scss'

const CaluRawInput = ({ labelText, countryCode, enterToSubmit = false, type, helperTextClassName, ...rest }) => {
  const height = rest.multiline ? 'auto' : '48px'
  const [showPassword, setShowPassword] = useState(false)
  const handleToggleVisibility = () => setShowPassword((prev) => !prev)

  const showStartAdorment = () => {
    if (countryCode) return `+${countryCode}`
    if (type === 'DI') return <BadgeIcon color="action" />
    return null
  }

  const showEndAdorment = () => {
    if (type === 'password') {
      return (
        <InputAdornment position="end">
          <IconButton onClick={handleToggleVisibility} edge="end">
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      )
    }
    return null
  }

  return (
    <div>
      {labelText && <div className={s.titleInput}>{labelText}</div>}
      <div className={`${s.defaultStyles} ${rest.className}`} style={{ height }}>
        <STextField
          type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
          InputProps={{
            startAdornment: showStartAdorment(),
            endAdornment: showEndAdorment(),
            classes: {
              notchedOutline: s.notchedOutline,
            },
          }}
          inputProps={{
            maxLength: rest.maxLength,
          }}
          FormHelperTextProps={{
            className: rest.error ? undefined : helperTextClassName,
          }}
          onWheel={(e) => e.target.blur()}
          helperText={rest?.error && rest.helperText}
          onKeyDown={enterToSubmit ? null : handleKeyDown}
          {...rest}
        />
      </div>
    </div>
  )
}

export default CaluRawInput

CaluRawInput.propTypes = {
  type: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  labelText: PropTypes.string,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  maxRows: PropTypes.number,
  maxLength: PropTypes.number,
  helperTextClassName: PropTypes.string,
}
